import { Injectable } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  public modalRef: MdbModalRef<any>;
  public closeDialogSubject: Subject<any> = new Subject();
}
